import { render, staticRenderFns } from "./Permit.vue?vue&type=template&id=d70b7562&scoped=true"
import script from "./Permit.vue?vue&type=script&lang=js"
export * from "./Permit.vue?vue&type=script&lang=js"
import style0 from "./Permit.vue?vue&type=style&index=0&id=d70b7562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70b7562",
  null
  
)

export default component.exports